import axios from 'axios';

import config from '../../config';
import { getUserToken } from '../../ducks/user.duck';

export const sendDeclineBookingsOnSameTimeslot = async (transactionId) => {
  if (!config.bookingsServiceUri) return ;

  const url = `${config.bookingsServiceUri}/api/accept`;
  const token = getUserToken();
  try {
    return await axios({
      method: 'POST',
      url,
      headers: {
        "authorization": `Bearer ${token}`,
        "content-type": "application/x-www-form-urlencoded",
      },
      data: `transactionId=${transactionId}`
    });
  } catch (e) {
    console.error(e);
  }
};



// WEBPACK FOOTER //
// ./src/util/bookingsHelpers/index.js